import React from 'react';
import { Checkbox } from '../Checkbox';
import { CHECKLIST_ITEMS } from './formData';
interface ReadinessChecklistProps {
  checkedItems: string[];
  onChange: (items: string[]) => void;
}
export function ReadinessChecklist({
  checkedItems,
  onChange
}: ReadinessChecklistProps) {
  const toggle = (item: string, checked: boolean) => {
    if (checked) onChange([...checkedItems, item]);else onChange(checkedItems.filter(i => i !== item));
  };
  return <div className="mt-12 rounded-[calc(var(--radius)+0.25rem)] border border-[hsl(var(--border))] bg-[hsl(var(--muted))]/30 p-6 sm:p-8" data-id="element-100">
      <h3 className="mb-6 text-lg font-semibold tracking-tight text-[hsl(var(--foreground))]" data-id="element-101">
        Submission Readiness Checklist
      </h3>
      <div role="group" aria-label="Submission Readiness Checklist" className="flex flex-col gap-4" data-id="element-102">
        {CHECKLIST_ITEMS.map(item => <label key={item} className="flex cursor-pointer items-start gap-3" data-id="element-103">
            <Checkbox checked={checkedItems.includes(item)} onCheckedChange={checked => toggle(item, checked === true)} className="mt-0.5" data-id="element-104" />
            <span className="text-sm leading-relaxed text-[hsl(var(--foreground))]" data-id="element-105">
              {item}
            </span>
          </label>)}
      </div>
    </div>;
}